import { ajax } from "discourse/lib/ajax";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class ModMarketShowRoute extends DiscourseRoute {
  queryParams = {
    tab: { refreshModel: false },
    version: { refreshModel: false },
  };

  model({ mod_id }) {
    return ajax(`/mod-market-api/v1/mods/${mod_id}.json`).then(
      (response) => response.mod
    );
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.favorited = model.favorited;
    controller.favoriteCount = model.stats?.favorites || 0;
    controller.setupComposerMessaging();
  }

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.tab = "description";
      controller.version = null;
      controller.commentComposerOpen = false;
      controller.detailsExpanded = false;
      controller.teardownComposerMessaging();
    }
  }

  titleToken(model) {
    return model?.title || i18n("discourse_mod_market.title");
  }
}
